import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface IPxJwtTokenProviderService {
    fetchToken(): Observable<string>;
}

@Injectable()
export class PxJwtTokenProviderService implements IPxJwtTokenProviderService {
    fetchToken(): Observable<string> {
        return of('no-token-provided');
    }
}
